import PosBillService from '@/api/PosBillService'

// initial state
const state = {
  posbills: [],
  posbill: null,
}

// getters
const getters = {
  getPosBills: state => state.posbills,
  getPosBill: state => state.posbill,
}

// mutations
const mutations = {
  setPosBills (state, data) {
    state.posbills = data
  },
  setPosBill (state, data) {
    state.posbill = data
  },
}

// actions
const actions = {
  async getPosBills ({ commit }, param = '') {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosBills') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosBills')

      let response = await PosBillService.getAll(param)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosBills')

      result = response.data

      if (result.success) {
        commit('setPosBills', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearPosBills ({ commit }) {
    commit('setPosBills', [])
  },
  async getPosBill ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosBill') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosBill')

      let response = await PosBillService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosBill')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setPosBill', result.data[0])
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearPosBill ({ commit }) {
    commit('setPosBill', [])
  },
  async insertPosBill ({ commit }, data) {
    var result = null
    var isError = false
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await PosBillService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        isError = true
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      isError = true
    }

    if (isError) {
      let foundBill = this.getters.getPosStockBill(data.uuid)
      if (!foundBill) {
        this.dispatch('addPosStockBill', data)
      }
    }

    return result
  },
  async insertPosBillRefund ({ commit }, data) {
    var result = null
    var isError = false
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await PosBillService.refundInsert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }

    return result
  },
  async getPosBillLatestCode ({ commit }, params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosBillLatestCode') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosBillLatestCode')

      let response = await PosBillService.getLatestCode(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosBillLatestCode')

      result = response.data

      if (result.success) {
        this.dispatch('setPosLatestQueueNumber', result.data.latest)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async getPosBillUSedCodes ({ commit }, params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPosBillUSedCodes') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPosBillUSedCodes')

      let response = await PosBillService.getUsedCode(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPosBillUSedCodes')

      result = response.data

      if (result.success) {
        this.dispatch('setPosUsedQueueNumbers', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async sentReceiptEmail ({ commit }, { posbiId, data }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('sentReceiptEmail') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'sentReceiptEmail')

      let response = await PosBillService.sentReceiptEmail(posbiId, data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'sentReceiptEmail')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/PosBill.js